import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";
import { calculateRem } from "styles/mixins/mixins";

import { Select } from "components/SelectUI/Select";
import { CssButton, CssFlex, CssGrid } from "styles/helpers/layout";

export const StyledSelect = styled(Select)<Props>`
  width: ${calculateRem(396)};
`;

export const StyledSubtitle = styled.span<Props>`
  font-size: ${(props: Props) => props.theme.font.size._18};
  color: ${(props: Props) => props.theme.palette.neutral._500};
`;

export const StyledMainSection = styled(CssFlex)<Props>`
  max-width: max-content;
`;

export const StyledTestEnvCard = styled(CssGrid)<Props>`
  width: 21rem;
  min-height: 21rem;
  border-radius: 16px;

  justify-items: center;
  grid-template-rows: 1fr auto auto;

  padding: 1rem;
  background: ${(props: Props) => props.theme.palette.secondary._950};
  border: solid 1px ${(props: Props) => props.theme.palette.neutral._800};

  ${CssButton} {
    font-weight: 400;
    border-radius: 8px;
    padding: 0.3rem 1.5rem;
  }
`;
